import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { IbPipesModule } from 'ib/internetbank-core/ib-pipes/ib-pipes.module';

import { CommonAppModule } from '../../common/common-app.module';
import { CommonProductsModule } from '../../products/common/products-common.module';
import { LeftPanelModule } from '../../products/left-panel/left-panel.module';
import { NotificationsModule } from '../../shared/notifications/notifications.module';
import { StoriesModule } from '../../shared/stories/stories.module';
import { SvgCommonModule } from '../../shared/svg/svg-common.module';
import { UiModule } from '../../ui/ui.module';
import { FavoritesModule } from '../operations/favorites/favorites.module';
import { InvoicingSharedModule } from '../operations/invoicing/invoicing-shared.module';
import { PaymentWidgetsModule } from '../operations/payments/payment-widgets/payment-widgets.module';
import { PaymentsSharedModule } from '../operations/payments/payments-shared.module';
import { TransfersSharedModule } from '../operations/transfers/transfers-shared.module';

import { BannersModule } from './banners/banners.module';
import { CreditHistoryComponent } from './credit-history/credit-history.component';
import { MainSectionComponent } from './main-section.component';
import { NotifiesComponent } from './notifies/notifies.component';

@NgModule({
	imports: [
		CommonModule,
		CommonAppModule,
		RouterModule,
		UiModule,
		SvgCommonModule,
		LeftPanelModule,


		PaymentsSharedModule,
		PaymentWidgetsModule,

		TransfersSharedModule,
		InvoicingSharedModule,

		FavoritesModule,

		CommonProductsModule,
		NotificationsModule,
		BannersModule,
		StoriesModule,

		IbPipesModule,
	],
	declarations: [
		MainSectionComponent,
		NotifiesComponent,
		CreditHistoryComponent,
	],
})
export class MainSectionModule { }
